import BaseApi from './base-api';

export const WhatsAppService = {
  // Send order confirmation
  sendOrderConfirmation: async (orderId: string) => {
    return await BaseApi.post(`/whatsapp/order-confirmation`, { orderId });
  },

  // Send order status update
  sendOrderStatusUpdate: async (orderId: string) => {
    return await BaseApi.post(`/whatsapp/order-status`, { orderId });
  },

  // Send delivery OTP
  sendDeliveryOTP: async (orderId: string) => {
    return await BaseApi.post(`/whatsapp/delivery-otp`, { orderId });
  },

  // Send delivery assignment
  sendDeliveryAssignment: async (orderId: string) => {
    return await BaseApi.post(`/whatsapp/delivery-assignment`, { orderId });
  },

  // Send gift notification
  sendGiftNotification: async (recipientPhone: string, giftDetails: any) => {
    return await BaseApi.post('/whatsapp/gift-notification', {
      recipientPhone,
      giftDetails
    });
  },

  // Test connection
  testConnection: async (phone: number) => {
    return await BaseApi.post('/whatsapp/test', { phone });
  },

  // Check status
  getStatus: async () => {
    return await BaseApi.get('/whatsapp/status');
  }
};